import { useState, useEffect } from 'react'
import { unsupportedWebFormats } from 'components/stream-messaging/utils'

export const useVideoAnalysis = (
  attachments = [],
  mediaInfoFactory = null,
  shouldAnalyze = false,
) => {
  const [nonCompliantVideos, setNonCompliantVideos] = useState([])

  useEffect(() => {
    // Check for video/mp4 attachments
    const videoAttachments = attachments?.filter(
      att => att.mime_type === 'video/mp4' && att.asset_url,
    )

    if (videoAttachments?.length && !!mediaInfoFactory && shouldAnalyze) {
      const analyzeVideos = async () => {
        try {
          const mediaInfo = await mediaInfoFactory()

          // Process all videos in parallel and collect indices of non-compliant ones
          const results = await Promise.all(
            videoAttachments.map(async (attachment, index) => {
              try {
                const response = await fetch(attachment.asset_url)
                const blob = await response.blob()

                const getSize = () => blob.size
                const readChunk = async (chunkSize, offset) => {
                  const buffer = await blob
                    .slice(offset, offset + chunkSize)
                    .arrayBuffer()
                  return new Uint8Array(buffer)
                }

                const result = await mediaInfo.analyzeData(getSize, readChunk)

                if (result.media?.track) {
                  const videoTrack = result.media.track.find(
                    track => track['@type'] === 'Video',
                  )

                  if (
                    videoTrack &&
                    unsupportedWebFormats.includes(videoTrack.Format)
                  ) {
                    return index // Return index if non-compliant
                  }
                }
                return null // Return null if compliant or couldn't determine
              } catch (err) {
                console.error('Error analyzing video:', err)
                return null
              }
            }),
          )
          setNonCompliantVideos(results.filter(index => index !== null))
          mediaInfo.close()
        } catch (err) {
          console.error('Error initializing mediaInfo:', err)
        }
      }

      analyzeVideos()
    }
  }, [attachments, mediaInfoFactory, shouldAnalyze])

  return nonCompliantVideos
}
